/* eslint-disable react-hooks/exhaustive-deps */
import { useEffect } from "react"
import { CSSBorder, IImageData } from "src/libs/interfaces/layouts"
import addCSSClass from "src/libs/layout-app/utils/addCSSClass"
import removeCSSClass from "src/libs/layout-app/utils/removeCSSClass"
import { __ } from "src/libs/utilities"
import { getCssDemention } from "src/libs/utilities/getCssDemention"
import getURLToImageData from "src/libs/utilities/getURLToImage"
import { useSyncState } from "src/modules/pe-basic-module/hooks/useSyncState"
import { ImageContent } from "src/modules/pe-landing-module/data/interfaces"
import usePosition from "src/modules/pe-landing-module/hooks/usePosition"
import "../../../assets/css/Image.scss"
import ImageEditor from "../landing-edit/editors/image-editor/ImageEditor"
import { IPrimitiveProps } from "../section/Primitive"
import LinkContainer from "../useful/LinkContainer"
import backgroundSize from "./image/backgroundSize"
import useLandingSize from "src/modules/pe-landing-module/hooks/useLandingSize"

/* Protopia Ecosystem component */ 
const ImagePrimitive = ( props: IPrimitiveProps ): JSX.Element => { 
    const primitive: ImageContent = props.primitive as ImageContent
    const { data, style, border, height } = primitive
    const { position }  = usePosition(primitive) 
    const lSizes        = useLandingSize()         
    // данные файла
    const sizes = useSyncState<IImageData>({src: data.src, width:0, height:0, aspect: 1} as IImageData)
    // данные визуального отображения
    const sz = useSyncState<IImageData>({ src: "", width:0, height:0, aspect: 1})

    const _border: CSSBorder = border || {} as CSSBorder
    const APPROXIMATION = primitive.hover_size || 0

    // console.log( position, primitive )

    // eslint-disable-next-line
    useEffect(() => { 
        getURLToImageData(primitive.src || data.src || "")
            .then(
                (res: IImageData) => { 
                    sizes.set({
                        src: res.src,
                        width: res.width,
                        height: res.height,
                        aspect: res.width / res.height, // res.aspect
                    }) 
                    const img = document.querySelector( `.landing-image-${primitive?.id}` ) 
                    
                    const ww = parseInt(( getWidth() || img?.clientWidth  )?.toString() || "0")
                    const hh = parseInt(( getHeight() || img?.clientHeight )?.toString() || "0")
                    const aspect = primitive.aspect ? primitive.aspect : ww / hh
                    sz.set({
                        width: ww,
                        height: hh,
                        src: res.src, 
                        aspect,
                    })
                    addCSSClass(
                        `landing-image-${primitive?.id}`,
                        ` 
                        .image-${ primitive?.id } {
                            width: ${ getCssDemention( getWidth(), "100%" ) };
                            height: ${ getCssDemention( getHeight(), "auto" ) };
                        }
                        .landing-image-${ primitive?.id } {
                            background-image: url(${ data.src || primitive.src }); 
                            ${backgroundSize(sz.get(), sizes.get(), position, 0, false, false) };
                             
                            border-width: ${ getCssDemention( _border.borderWidth, "0" ) };
                            border-radius:${ getCssDemention( _border.borderRound?.border, "2px") };
                            border-style: ${ _border.borderStyle || "solid" };
                            border-color: ${ _border.borderColor || "var(--force-contast-color)"};
                            width: ${ getCssDemention(getWidth(), "100%") };
                            max-width: ${ getCssDemention(getWidth(), "100%") };
                            height: ${ getCssDemention( position.height || height, primitive.aspect ? "auto" : "100%") };
                            aspect-ratio: ${ primitive.aspect };
                            ${ position.opacity ? `opacity:${ position.opacity };` : ``}
                            ${ `transform: scale(${ position.scale || 1 }) rotate(${ position.rotate || 0 }deg);` }
                            transition: background-size .4s;
                            z-index: ${position.z || 0};
                            &:hover {
                                ${backgroundSize(sz.get(), sizes.get(), position, APPROXIMATION, false, false) }; 
                            }
                        }
                        .landing-image-img-${primitive?.id} {
                            width: ${ getCssDemention(position.width, "100%") };
                            ${
                                !!position.height || height
                                    ? 
                                    `height: ${ getCssDemention(position.height  || height, "auto") }` 
                                    : 
                                    "" 
                            };
                            ${ 
                                !!_border 
                                    ? 
                                    `border-width: ${ getCssDemention( _border.borderWidth, "0" ) };
                                    border-radius:${ getCssDemention( _border.borderRound?.border || _border.borderRound, "2px") };
                                    border-style: ${ _border.borderStyle || "solid" };
                                    border-color: ${ _border.borderColor || "var(--force-contast-color)"};` 
                                    : 
                                    `` 
                            } 
                            ${ position.opacity ? `opacity:${ position.opacity };` : ``}
                            ${ `transform: scale(${ position.scale || 1 }) rotate(${ position.rotate || 0 }deg);` }
                            img {
                                width: auto;
                                height:${getCssDemention(position.height || height, "auto")};
                            }
                            z-index: ${position.z || 0};
                        }
                        `
                    )
                } 
            )
            .catch((e: Error) => {                
                // console.error("Image primitive error:")                
                // console.error(e)                
            })
        return () => {
            removeCSSClass(`landing-image-${primitive?.id}`)
        }
    }, [ position, primitive, ]) 
     
    const getWidth = () => {        
        const w = !!position.width 
            ?
            position.width 
            :
            sizes.get().aspect * parseInt((position.height || height)?.toString() || "100%" )
        return w
    }
    const getHeight = () => {
        const h = !!(position.height || height)
            ?
            (position.height || height)
            :

            undefined //"auto"  
            /* 
            *  CardList.thumbnail = undefined 
            */
        return h
    }  
    return <ImageEditor 
        { ...props } 
        className={ `pe-primitive-container landing-image-link image-${ primitive?.id }` } 
        sizes={ sizes.get() } 
    >
        <LinkContainer
            link_url={ data?.link_url }
            link_target={ data?.link_target }
            className={ `pe-primitive-container landing-image-link image-${ primitive?.id } ${ primitive.link_class_name || "" }` }
            data-primitive-type={primitive["data-primitive-type"]}
            data-primitive-id={primitive.id}
        >   
            {
                (data?.src_type || primitive.src_type) === "src"
                    ?
                    !!(data?.src || primitive.src)
                        ?
                        <div className={`landing-image landing-image-img-${primitive?.id} ${ data?.className || "" }  ${primitive.className || ""}`} >
                            <img 
                                src={data?.src || primitive.src} 
                                alt={data.description_title} 
                                className={`landing-image  ${ !!position.className ? position.className : data.className || "" } `} 
                                style={{ 
                                    maxWidth: position.width, 
                                    width: position.width, 
                                    height: position.height || height || "auto", //getHeight(), 
                                    aspectRatio: primitive.aspect || undefined,
                                    ...style, ...position.style, 
                                }} 
                            />
                            {
                                data.is_contrast_muar && <div className="muar"></div>                            
                            }
                            <Description {...data} />
                        </div>
                        :
                        <></>
                    :
                    !!(data?.src || primitive.src)
                        ?
                        <div 
                            className={ `landing-image landing-image-${ primitive?.id } ${ data?.className || "" } ${ primitive.className || "" }` } 
                            style={{ 
                                maxWidth: getWidth(), 
                                width: getWidth(), 
                                height: getHeight(),
                                ...style, 
                                ...position.style,
                            }} 
                        > 
                            <Description
                                description={primitive.description || data.description} 
                                description_title={primitive.description_title || data.description_title}
                                description_class_name={primitive.description_class_name || data.description_class_name}
                                description_style={primitive.description_style || data.description_style}
                            /> 
                        </div>
                        :
                        <></>
            }  
        </LinkContainer>
    </ImageEditor>
}
export default ImagePrimitive

const Description = ({description, description_title, description_class_name, description_style}:any) : JSX.Element => {
    return !!description_title || !!description
        ?
        <div className={"landing-image-descr-container " + description_class_name} style={description_style}>
            <div 
                className="landing-image-descr-title"
                dangerouslySetInnerHTML={{__html:__(description_title)}}
            />
            <div 
                className="landing-image-descr"
                dangerouslySetInnerHTML={{__html:__(description)}}
            />
        </div>
        :
        <></>
}